const HTML_COMMENT = /<!--[\s\S]*?-->/g;
const HTML_TAG = /<[^>]*>/g;
const NON_BREAKING_SPACE_ENTITY = /&nbsp;|&#0*160;|&#x0*a0;/gi;
const HTML_ENTITY = /&(#\d+|#x[0-9a-f]+|[a-z][a-z0-9]*);/gi;

/**
 * Returns true when the welcome message would render visible text.
 *
 * Must return the same result on the server and the client so the Announcements panel stays on the
 * same branch through hydration. It works purely on the string — no browser-only `DOMParser`, which
 * is unavailable during SSR — by stripping comments and tags, treating non-breaking spaces as
 * whitespace and any other HTML entity as a visible glyph (e.g. `&amp;` → `&`), then checking
 * whether any non-whitespace text remains.
 */
export const hasVisibleWelcomeMessageContent = (messageHtml?: string | null): boolean => {
	if (!messageHtml) {
		return false;
	}

	const textContent = messageHtml
		.replace(HTML_COMMENT, '')
		.replace(HTML_TAG, '')
		.replace(NON_BREAKING_SPACE_ENTITY, ' ')
		.replace(HTML_ENTITY, 'x');

	return textContent.trim().length > 0;
};
